const scrollContainers = document.querySelectorAll('.js-scroll-to')

if (scrollContainers.length != 0) {
    scrollContainers.forEach((container) => {
        const link = container.querySelector('a')
        const href = link.getAttribute('href')

        link.addEventListener('click', function (e) {
            if (href.includes('#')) {
                e.preventDefault()
                const target = document.querySelector(href)

                const targetOffset = target.offsetTop

                window.scrollTo({
                    top: targetOffset,
                    behavior: 'smooth',
                })
            }
        })
    })
}
